import { nextFrame } from "../../../library-js/animation/nextFrame";
import { sleep } from "../../../library-js/animation/sleep";
import { ImageRotater, ImageRotaterElement } from "../../../library-js/dom-actions/ImageRotater";
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Insight } from "../../../library-js/dom-tools/Insight";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { SVGEditor } from "../../../library-js/svg/SVGEditor";
import { TemplateReplacer } from "../../../library-js/templates/TemplateReplacer";
import { TemplatesManager } from "../../../library-js/templates/TemplatesManager";
import { TemplatesList } from "../../templates/TemplatesList";
import { Rokojori } from "../Rokojori";
import { ActionType } from "./data-types/ActionType";
import { ProductInfo } from "./ProductInfo";
import { ProductType } from "./data-types/ProductType";
import { CreatorID } from "./data-types/CreatorInfo";
import { ProductsTable } from "./ProductsTable";
import { SVGTextSetter } from "../../../library-js/svg/SVGTextSetter";
import { Inkscape } from "../../../library-js/svg/Inkscape";
import { StoreSortation, StoreStortingType as StoreSortingType } from "./StoreSortation";
import { RootPathResolver } from "../../../library-js/dom-tools/RootPathResolver";
import { AddToCartLink } from "../cart/AddToCartLink";

export class StoreView
{
  static readonly type = new ElementType( "store-view" );
  static readonly items = new ElementType( "store-items" );
  static readonly item = new ElementType( "store-item" );
  static readonly image = new ElementAttribute( "image" );

  static readonly store = new ElementAttribute( "store" );
  
  static readonly displayValue = new AttributeValue( StoreView.store, "display-value" );
  static readonly displayLabel = new AttributeValue( StoreView.store, "display-label" );


  static readonly productName       = new ElementAttribute( "product-name" );
  static readonly productType       = new ElementAttribute( "product-type" );
  static readonly productDetails    = new ElementAttribute( "product-details" );
  static readonly productTags       = new ElementAttribute( "product-tags" );
  static readonly productVendor     = new ElementAttribute( "product-vendor" );
  static readonly productPrice      = new ElementAttribute( "product-price" );
  static readonly productAction     = new ElementAttribute( "product-action" );


  static applyOnDocument()
  {
    StoreView.type.forAllInDoc( e => StoreView.applyOnElement( e ) );
  }

  static changeLandscapeView( element:Element )
  {
    let views = 
    [
      "large-2",
      "big-3",
      "normal-3",
      "small-4",
      "small-5"
    ];
    
    let flags:ClassFlag[] = []; 
    views.forEach(
      ( v )=>
      {
        flags.push( new ClassFlag( v ) );
      }
    )
    	
    let current = flags.find( f => f.in( element ) );
      
    console.log( "Current view: ", current );

    if ( current != null )
    {
      let currentIndex = flags.indexOf( current );
      let nextIndex = ( currentIndex + 1 ) % flags.length;
      current = flags[ nextIndex ];
    }
    else
    {
      current = flags[ 0 ];
    }

    console.log( "Next view: ", current );

    flags.forEach( f => f.setAs( element, f == current ) );    
   
  }

  static async applyOnElement( e:Element )
  {
    let inputRootPath = "::/en/products/all";
    let convertedPath = Rokojori.$.pathConverter.rootToRelative( inputRootPath );

    console.log( "PROCESSING STORE VIEW", inputRootPath, convertedPath );
    let table = await ProductsTable.get();
    
    console.log( table );

    let changers:Element[] = [];
    changers = changers.concat( StoreView.displayLabel.queryAllInDoc() );
    changers = changers.concat( StoreView.displayValue.queryAllInDoc() ); 

    console.log( "CHANGERS", changers, "IN DOC", StoreView.store.queryDocAll() );

    changers.forEach(
      ( c )=>
      {
        OnClick.add(  c as HTMLElement,
           ()=> 
           {
             console.log( "CLCK" );
             StoreView.changeLandscapeView( e ) 
           }
        );
      }
    )

    let products:ProductInfo[] = table.products;

    products = this.filterProducts( [].concat( products ) );
    
    this.sortProducts( products );

    this.displayProducts( e, products );
  }

  static filterProducts( products:ProductInfo[] ):ProductInfo[]
  {
    return products;
  }

  static sortProducts( products:ProductInfo[] )
  { 
    let sortation = new StoreSortation();
    sortation.type = StoreSortingType.PRICE;
    
    sortation.sort( products );
  }


  static async displayProducts( e:Element, products:ProductInfo[] )
  {
    let itemSource     = StoreView.item.query( e );
    let itemsContainer = StoreView.items.query( e );

    itemsContainer.innerHTML = "";

    for ( let i =0 ; i < products.length; i++ )
    {
      let element = itemSource.cloneNode( true ) as Element;
      
      SVGEditor.cloneSVGs( element );
      let images = StoreView.image.queryAll( element );
      //let imagePath = "../_graphics/store/blender-3.2-image.jpg";
      let imagePath =Rokojori.locale( products[ i ].imagePath ); 
      imagePath = Rokojori.$.pathConverter.rootToRelative( imagePath );

      let productLink = Rokojori.locale( products[ i ].link );
      let actionLink = Rokojori.locale( products[ i ].actionLink );
     

      let links = ElementType.anchor.queryAll( element );

      links.forEach(
        ( l )=>
        { 
          let hrefValue = ElementAttribute.href.from( l );

          let oldVlaue = hrefValue;
          
          hrefValue = hrefValue.replace( "{product-page}", productLink );
          hrefValue = hrefValue.replace( "{action}", actionLink );

          if ( RootPathResolver.isRootPath( hrefValue ) )
          {
            hrefValue = Rokojori.$.pathConverter.rootToRelative( hrefValue );
          }

         
          
          console.log( oldVlaue, ">>", hrefValue );
          ElementAttribute.href.to( l, hrefValue );

          if ( AddToCartLink.is( l ) )
          {
            let id = products[ i ].id;
            AddToCartLink.applyElement( l, id, false );
          } 
          else
          {
            Rokojori.$.pageHandler.makePageHandleLink( l );
          }
        

          
        }
      );

      
      StoreView.setProductText( element, StoreView.productName, products[ i ].name, true );
      StoreView.setProductMultilineText( element, StoreView.productDetails, products[ i ].details );
      StoreView.setProductText( element, StoreView.productType, ProductInfo.getType( products[ i ] ) );
      StoreView.setProductText( element, StoreView.productTags, ProductInfo.getTags( products[ i ] ) );
      StoreView.setProductText( element, StoreView.productAction, ProductInfo.getAction( products[ i ] ) );
      StoreView.setProductText( element, StoreView.productVendor, ProductInfo.getCreatorInfoName( products[ i ] ) );
      //StoreView.setProductText( element, StoreView.productPrice, ProductInfo.getPrice( products[ i ] ) );

      let overlays = products[ i ].overlays || [];
      let overlayLayers = Inkscape.getLayers( element as SVGElement, "Overlays" );
      overlays.forEach(
        ( layerName )=>
        {
          overlayLayers.forEach(
            ( ol )=>
            {
              let layers = Inkscape.getLayers( ol as SVGElement, layerName );
              layers.forEach( l => l.style.display = "inline" );
            }
          )
        }
      );

      images.forEach( image => SVGEditor.xlinkHref.to( image, imagePath ) );

      itemsContainer.appendChild( element );

      Rokojori.$.insight.grabElements();

      let imageRotatorElement = ImageRotater.type.query( element ) as ImageRotaterElement;
      ImageRotater.addElement( imageRotatorElement );

      await nextFrame();
      await nextFrame();

      ClassFlag.visible.set( element );

      await nextFrame();
    }

    
  } 

  
  static setProductMultilineText( element:Element, att:ElementAttribute, value:string|MultiString, upperCase:boolean = false )
  {
    let svgElements = att.queryAll( element ) as SVGElement[];

    let textValue = StoreView.grabText( value, upperCase );

    let textSetter = new SVGTextSetter();
    let container = document.createElement( "span" );
    container.innerHTML = textValue;


    svgElements.forEach( 
      ( svgElement ) => 
      { 
        svgElement.innerHTML = "";
        textSetter.setText( svgElement as SVGTextElement, container );
      }
    );
  }

  

  static setProductText( element:Element, att:ElementAttribute, value:string|MultiString, upperCase:boolean = false )
  {
    let svgElements = att.queryAll( element ) as SVGElement[];

    let textValue = StoreView.grabText( value, upperCase );

    svgElements.forEach( ( svgElement ) => { SVGEditor.setText( svgElement, textValue ); } );

  }

  static grabText( value:string|MultiString, upperCase:boolean )
  {
    let textValue = "";

    if ( typeof value == "string" )
    {
      textValue = value as string;
    }
    else
    {
      textValue = Rokojori.locale( value as MultiString );
    }

    if ( upperCase )
    {
      textValue = textValue.toUpperCase();
    }

    return textValue;
  }
}